'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function renderChildren(props) {
  return _react2.default.Children.map(props.children, function (child) {
    // if child is not a tab we don't need to clone it
    // since we don't need to add custom props

    if (child.type !== _Tab2.default) {
      return child;
    }

    var clonedProps = {
      activeTabClassName: props.activeTabClassName,
      disabledTabClassName: props.disabledTabClassName
    };

    return _react2.default.cloneElement(child, clonedProps);
  });
}

module.exports = (0, _createReactClass2.default)({
  displayName: 'TabList',

  propTypes: {
    className: _propTypes2.default.string,
    activeTabClassName: _propTypes2.default.string,
    disabledTabClassName: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
  },

  render: function render() {
    var _props = this.props,
        className = _props.className,
        activeTabClassName = _props.activeTabClassName,
        disabledTabClassName = _props.disabledTabClassName,
        children = _props.children,
        attributes = _objectWithoutProperties(_props, ['className', 'activeTabClassName', 'disabledTabClassName', 'children']);

    return _react2.default.createElement(
      'ul',
      _extends({}, attributes, {
        className: (0, _classnames2.default)('ReactTabs__TabList', className),
        role: 'tablist'
      }),
      renderChildren({ activeTabClassName: activeTabClassName, disabledTabClassName: disabledTabClassName, children: children })
    );
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-tabs/lib/components/TabList.js
// module id = 1460
// module chunks = 0